import axios from "axios";

export async function fetchConciergeImagesByBusinessNumber(storeBusinessNumber) {
  const sbn = String(storeBusinessNumber || "").trim();
  if (!sbn) {
    return { images: [], userId: 0, storeName: "", menu1: "", menu2: "", menu3: "" };
  }

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_FASTAPI_ADS_URL}/stores/by-business/${encodeURIComponent(
        sbn
      )}/concierge/images`,
      { timeout: 8000 }
    );

    return {
      userId: Number(res?.data?.user_id || 0),
      storeName: res?.data?.store_name || "",
      menu1: res?.data?.menu_1 || "",
      menu2: res?.data?.menu_2 || "",
      menu3: res?.data?.menu_3 || "",
      images: Array.isArray(res?.data?.images) ? res.data.images : [],
    };
  } catch {
    return { images: [], userId: 0, storeName: "", menu1: "", menu2: "", menu3: "" };
  }
}

export async function updateConciergeImagesByBusinessNumber({
  storeBusinessNumber,
  removedFileIds = [],
  newFiles = [],
}) {
  const sbn = String(storeBusinessNumber || "").trim();
  if (!sbn) {
    throw new Error("store_business_number is required");
  }

  const formData = new FormData();
  removedFileIds.forEach((id) => {
    if (id !== null && id !== undefined) {
      formData.append("removed_file_ids", String(id));
    }
  });
  newFiles.forEach((file) => {
    if (file) formData.append("new_files", file);
  });

  const res = await axios.post(
    `${process.env.REACT_APP_FASTAPI_ADS_URL}/stores/by-business/${encodeURIComponent(
      sbn
    )}/concierge/images`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 15000,
    }
  );

  return {
    userId: Number(res?.data?.user_id || 0),
    storeName: res?.data?.store_name || "",
    menu1: res?.data?.menu_1 || "",
    menu2: res?.data?.menu_2 || "",
    menu3: res?.data?.menu_3 || "",
    images: Array.isArray(res?.data?.images) ? res.data.images : [],
  };
}
